import {Endpoint} from '@eryxcoop/appyx-comm';

export default class EditCustomerCollectionsEmailEndpoint extends Endpoint {

    adaptValues({taxpayerIdentificationNumber, collectionsEmail}) {
        return {
            taxpayer_identification_number: taxpayerIdentificationNumber,
            collections_email: collectionsEmail,
        }
    }
}
